<template>
    <product-card-layout-mobile
        class="activity-card-mobile"
        :product-link="productLink"
        :name="product.info.name"
        :thumb="product.mainImage"
        :offers-count="product.offers && product.offers.length"
        :is-recommended="product.recommended"
        :is-add-on="isAddOn"
        :_expanded-count="expanded"
        :_expanded-limit="expandedLimit"
        @change-expanded-count="expanded = $event"
        @change-expanded-limit="expandedLimit = $event"
    >
        <template v-slot:wishlist>
            <wishlist-like
                :info="{
                    productType: 'activity',
                    mainImage: product.mainImage,
                    shortDescription: product.shortDescription,
                    info: {
                        name: product.info.name,
                        id: product.info.id,
                    },
                    offers: [],
                    searchRequest,
                }"
                :query="{id: product.info.id, productType: 'activity'}"
                :person="person"
                :product-runtime-store="productRuntimeStore"
                :in-wishlist="product.wishlist"
            />
        </template>
        <template v-slot>
            <template v-if="activityVenue">
                <VenueLabel
                    class="pt-2"
                    :venue-name="activityVenue.name"
                    :address="activityVenue.address"
                    :hide-show-on-map-button="!activityVenue.latitude || !activityVenue.longitude"
                    is-show-icon
                    @click="venueMapModal = true"
                />
                <client-only>
                    <v-dialog v-model="venueMapModal" :max-width="500">
                        <map-location
                            v-if="venueMapModal"
                            :latitude="activityVenue?.latitude"
                            :longitude="activityVenue?.longitude"
                            :height="`500px`"
                        />
                    </v-dialog>
                </client-only>
            </template>
            <div
                v-if="product.shortDescription"
                class="short-description mt-3"
                v-html="$filters.stripHtml(product.shortDescription)"
            />
            <v-row v-if="expanded">
                <v-col cols="12" class="my-3">
                    <date-filter-search v-model="dateFilter" outlined :dates-for-filter="datesForFilter" />
                </v-col>
            </v-row>
            <v-divider v-else-if="product.shortDescription" class="my-3" />
        </template>
        <template v-if="minPriceOffer" v-slot:price>
            <slot name="price" :offer="minPriceOffer" :offer-key="minPriceOffer.offerKey">
                <div v-if="!minPriceOffer.soldOut">
                    <div class="font-weight-medium text-h6">
                        <span>{{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}</span>
                    </div>
                    <discount-label :price="minPriceOffer.price" />
                    <commission-amount :commission="minPriceOffer.price.commission" />
                </div>
            </slot>
        </template>
        <template v-slot:offers>
            <activity-grouped-offers
                :dates-for-filter="datesForFilter"
                :sorted-filtered-offers="sortedFilteredOffers"
                :hide-price="hidePrice"
            >
                <template v-slot:price="{offer, offerKey}">
                    <slot name="price" :offer="offer" :offer-key="offerKey" />
                </template>
            </activity-grouped-offers>
            <template v-if="groupOffersBy === 'none'">
                <activity-offer-card
                    v-for="(offer, offerIndex) in sortedFilteredSlicedOffers"
                    :key="offerIndex"
                    :offer="offer"
                    :full-card="false"
                    :data-cy="`activity-offer-card-${offerIndex}`"
                >
                    <template v-slot:price>
                        <slot name="price" :offer="offer" :offer-key="offer.offerKey" />
                    </template>
                </activity-offer-card>
                <v-list-item
                    v-if="expanded === expandedLimit && sortedFilteredOffers.length > expandedLimit"
                    density="compact"
                    class="d-flex justify-center"
                    @click.stop="expand"
                >
                    <v-icon>mdi-chevron-down</v-icon>
                </v-list-item>
            </template>
        </template>
    </product-card-layout-mobile>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import {ActivityCard} from '@/components/activities/search/offers/ActivityCard.vue'
    import ActivityOfferCard from '@/components/activities/info/ActivityOfferCard.vue'
    import ActivityGroupedOffers from '~/components/activities/search/offers/ActivityGroupedOffers.vue'
    import ProductCardLayoutMobile from '~/components/search/ProductCardLayoutMobile.vue'
    import DateFilterSearch from '@/components/snippets/DateFilterSearch.vue'

    @Component({
        components: {
            DateFilterSearch,
            ActivityGroupedOffers,
            DiscountLabel,
            CommissionAmount,
            ActivityOfferCard,
            ProductCardLayoutMobile,
        },
    })
    export class ActivityCardMobile extends ActivityCard {}

    export default ActivityCardMobile
</script>
